import * as types from './types';

export const emitLogoutOnError = () => ({
  type: types.EMIT_LOGOUT_ON_ERROR,
});

export const onLogout = () => ({
  type: types.ON_LOGOUT,
});
